"use strict";
/**
 * @module Services.TopicNotifications
 */
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Data type for a TOPIC_DESCENDANT_EVENTS request.
 */
var TopicNotificationDescendantEvent = /** @class */ (function () {
    /**
     * Create a new TopicNotificationDescendantEvent instance
     *
     * @param cid   the conversation ID
     * @param path  the path that the topic notification refers to
     * @param type  the notification type
     */
    function TopicNotificationDescendantEvent(cid, path, type) {
        this.cid = cid;
        this.path = path;
        this.type = type;
        this.isDescendantEvent = true;
    }
    return TopicNotificationDescendantEvent;
}());
exports.TopicNotificationDescendantEvent = TopicNotificationDescendantEvent;



//////////////////
// WEBPACK FOOTER
// ./~/diffusion/src/internal/services/topic-notifications/topic-notification-descendant-event.js
// module id = 1471
// module chunks = 0